import * as S from './Title.style';

interface TitleProps {
  title: string;
}
export const Title = ({ title }: TitleProps) => {
  return <S.Title>{title}</S.Title>;
};
